export default __webpack_public_path__ + "static/media/admin.c7fe1c95.svg";